export default __webpack_public_path__ + "static/media/tumorChannel4.555a7786.png";